import { StandardEvents } from '@shopify/events';

class EarthImanPairingModal extends HTMLElement {
  #abortController = new AbortController();
  #trigger = null;
  #dialog = null;
  #closeButton = null;

  connectedCallback() {
    if (this.#abortController.signal.aborted) this.#abortController = new AbortController();
    this.#trigger = this.querySelector('[data-ei-pairing-open]');
    this.#dialog = this.querySelector('[data-ei-pairing-dialog]');
    this.#closeButton = this.querySelector('[data-ei-pairing-close]');

    if (!(this.#trigger instanceof HTMLButtonElement) || !(this.#dialog instanceof HTMLDialogElement)) return;

    const options = { signal: this.#abortController.signal };
    this.#trigger.addEventListener('click', this.#open, options);
    this.#closeButton?.addEventListener('click', this.#close, options);
    this.#dialog.addEventListener('cancel', this.#onCancel, options);
    this.#dialog.addEventListener('click', this.#onBackdropClick, options);
    this.#dialog.addEventListener('close', this.#onClose, options);
    this.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate, options);
  }

  disconnectedCallback() {
    this.#abortController.abort();
    if (this.#dialog?.open) this.#dialog.close();
    this.#unlockPage();
  }

  #open = () => {
    if (!this.#dialog || this.#dialog.open) return;
    this.#dialog.showModal();
    document.documentElement.setAttribute('scroll-lock', '');
    requestAnimationFrame(() => this.#closeButton?.focus({ preventScroll: true }));
  };

  #close = () => {
    if (this.#dialog?.open) this.#dialog.close();
  };

  #onCancel = (event) => {
    event.preventDefault();
    this.#close();
  };

  #onBackdropClick = (event) => {
    if (event.target === this.#dialog) this.#close();
  };

  #onClose = () => {
    this.#unlockPage();
    if (this.#trigger?.isConnected) this.#trigger.focus({ preventScroll: true });
  };

  #unlockPage() {
    if (!document.querySelector('dialog[open], theme-drawer[open]')) {
      document.documentElement.removeAttribute('scroll-lock');
    }
  }

  #onCartUpdate = (event) => {
    if (!this.#dialog?.open || !(event.target instanceof Element) || !this.#dialog.contains(event.target)) return;

    event.promise
      ?.then(({ detail }) => {
        if (detail?.didError || !this.#dialog?.open) return;

        this.#dialog.addEventListener(
          'close',
          () => {
            requestAnimationFrame(() => {
              const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
              if (typeof cartDrawer?.open === 'function') cartDrawer.open();
            });
          },
          { once: true }
        );

        this.#dialog.close('added');
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[earth-iman-pairings] Cart update failed:', error);
      });
  };
}

if (!customElements.get('ei-pairing-modal')) {
  customElements.define('ei-pairing-modal', EarthImanPairingModal);
}
